fbm.add("commands/login", ["util/io", "util/pause", "commands/connect"], function (uio, upause, cconnect) {

    let {
        parse,
        type,
    } = {
        ...uio,
        ...upause,
        ...cconnect,
    }

    async function login() {
        await type("> receiving evolved apes inc. security policy --PASS--");
        return parse("ealogin");
    }

    /** Login screen */
    return {
        login
    }
});
